export const SET_FILTER_DATA = 'SET_FILTER_DATA';

export type Filter = {
  [key: string]: string,
};
